import { render, staticRenderFns } from "./PanelBsCase.vue?vue&type=template&id=4f553526&scoped=true"
import script from "./PanelBsCase.vue?vue&type=script&lang=js"
export * from "./PanelBsCase.vue?vue&type=script&lang=js"
import style0 from "./PanelBsCase.vue?vue&type=style&index=0&id=4f553526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f553526",
  null
  
)

export default component.exports